import React from "react";
import PropTypes from "prop-types";
import { format, compareAsc } from "date-fns";

const formatDate = time => {
  return format(new Date(0, 0, 0, time.hour, time.minute), "h:mm a");
};

const DAYS = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

const WorkingHours = ({ data }) => (
  <div>
    {data.open24 && "Open 24 hours"}
    {data.workDays
      .sort(
        (day1, day2) =>
          DAYS.indexOf(day1.dayOfWeek) - DAYS.indexOf(day2.dayOfWeek),
      )
      .filter(day => day.from && day.to)
      .map(day => (
        <div key={day.dayOfWeek}>
          <b>{day.dayOfWeek}</b>: {formatDate(day.from)}–{formatDate(day.to)}
          {day.lunchTimeFrom && day.lunchTimeTo && (
            <div>
              Lunch time: {formatDate(day.lunchTimeFrom)}–
              {formatDate(day.lunchTimeTo)}
            </div>
          )}
        </div>
      ))}
  </div>
);

WorkingHours.propTypes = {
  data: PropTypes.object.isRequired,
};

export default WorkingHours;
